module.exports = __webpack_public_path__ + "static/media/Small_DianaConnolly_WIM_groupProject.411cad35.gif";